import { render } from "./templates/details.html?vue&type=template&id=156b1e36&external"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./stylesheets/index.scss?vue&type=style&index=0&lang=scss&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__